module.exports = __webpack_public_path__ + "UX45.png?9d7c86be98c22b9be18b71587c95997b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX45.png
// module id = 96
// module chunks = 0